'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('profile-picture-upload', {
      url: '/profile-picture-upload',
      template: '<profile-picture-upload></profile-picture-upload>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/user/profile-picture-upload/profile-picture-upload.routes.js